import { render, staticRenderFns } from "./DefaultSidebar.vue?vue&type=template&id=0bf7f8b8"
import script from "./DefaultSidebar.vue?vue&type=script&lang=js"
export * from "./DefaultSidebar.vue?vue&type=script&lang=js"
import style0 from "./DefaultSidebar.vue?vue&type=style&index=0&id=0bf7f8b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports